'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:ProductServiceCtrl
 * @description
 * # ProductCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.services')
  .factory('ProductCatalog', ['$http', 'domain', 'BaseService', 'toaster', function ($http, domain, BaseService, toaster) {
    var BASE_PROJECT_URL = domain.name + '/api/v1/products/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_PROJECT_URL,
      baseModelName: 'product'
    });

    baseService.error = function(error) {
      if(error && error.status === 422) {
        if('name' in error.data.errors) {
          toaster.pop('error', 'Producto', 'El nombre del producto ' + error.data.errors.name);
        }
        if('employee_id' in error.data.errors) {
          toaster.pop('error', 'Empleado', 'El empleado ' + error.data.errors.employee_id);
        }
        if('product_code' in error.data.errors) {
          toaster.pop('error', 'Código de Producto', 'El código del producto ' + error.data.errors.product_code);
        }
      }
      baseService.baseError(error);
    };

    return baseService;
  }]);
